// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Проєктний офіс» (Project office, ключ `pmo`, група `projects`). */
export const projectOfficeManifest: IModuleManifest = {
  key: 'pmo',
  group: 'projects',
  slug: 'project-office',
  prefix: 'PMO',
  name: { en: 'Project office', uk: 'Проєктний офіс' },
  entities: [
    { key: 'pmo', slug: 'pmo', name: { en: 'Standards', uk: 'Стандарти' }, main: true },
    { key: 'pmorep', slug: 'pmorep', name: { en: 'Status reports', uk: 'Звіти про стан' }, main: false },
  ],
  loadState: () => import('./state/projectOfficeSlice').then((m) => m.projectOfficeSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
